import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRODUCT_MOCKUP, offerGuarantees, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-navy px-5 py-20 sm:py-28" data-id="element-177" data-mp="1mmh6ocww56hf">
      <div className="mx-auto max-w-xl" data-id="element-178" data-mp="1hopj1v3a46j1">
        <h2 className="text-center font-display text-[1.9rem] font-extrabold leading-tight tracking-tight text-white sm:text-[2.8rem]" data-id="element-179" data-mp="1hpqva2w16z2c">
          <span aria-hidden="true" data-id="element-180" data-mp="u0obophu6w57">🏆 </span>Sonderangebot zum Start
        </h2>

        <div className="relative mt-10 rounded-[2rem] bg-white px-6 pb-8 pt-10 shadow-soft ring-4 ring-sun sm:px-10" data-id="element-181" data-mp="p1l9rdx5l61g">
          <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-sun px-5 py-2 font-display text-xs font-extrabold uppercase tracking-wide text-navy" data-id="element-182" data-mp="13uohktky05ez">
            MATHE BEREIT™ Paket
          </span>

          <img src={PRODUCT_MOCKUP} alt="MATHE BEREIT™ Paket mit 6 digitalen Bänden" className="mx-auto w-44 drop-shadow-[0_18px_24px_rgba(11,31,75,0.3)] sm:w-52" data-id="element-183" data-mp="2adwgsruwss38" />

          <table className="mt-6 w-full text-sm" data-id="element-184" data-mp="ui0js83f336k">
            <caption className="sr-only" data-id="element-185" data-mp="ziesztgr8j66">Inhalt und Wert des Pakets</caption>
            <tbody data-id="element-186" data-mp="zgafqkwyu7t8">
              {offerRows.map(row => <tr key={row.label} className="border-b border-ice-strong" data-id="element-187" data-mp="13iyrp1gz7uuf">
                  <th scope="row" className="py-4 pr-4 text-left font-normal" data-id="element-188" data-mp="6u97h4hvmq5a">
                    <span className="flex items-start gap-2" data-id="element-189" data-mp="bstz4fj2c1i4">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf" strokeWidth={3} aria-hidden="true" data-id="element-190" data-mp="btc5w63cpy4a" />
                      <span data-id="element-191" data-mp="fsb5db6bd2oc">
                        <span className="block font-bold text-navy" data-id="element-192" data-mp="kkvyeahebbqt">{row.label}</span>
                        <span className="block text-xs text-navy/60" data-id="element-193" data-mp="3k8lzept6dv0g">{row.detail}</span>
                      </span>
                    </span>
                  </th>
                  <td className="py-4 text-right font-display font-extrabold text-navy" data-id="element-194" data-mp="3o8o12yywuofq">{row.value}</td>
                </tr>)}
              <tr data-id="element-195" data-mp="qgxi0582zdpx">
                <th scope="row" className="py-4 text-left font-display font-extrabold uppercase text-navy" data-id="element-196" data-mp="qhfmtq8t709g">
                  Gesamtwert:
                </th>
                <td className="py-4 text-right font-display text-lg font-extrabold text-navy/60 line-through decoration-cherry decoration-2" data-id="element-197" data-mp="157d4rog5atq7">
                  193 €
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mt-4 rounded-2xl bg-ice px-4 py-6 text-center" data-id="element-198" data-mp="7il98kl305uv">
            <p className="inline-block rounded-full bg-cherry px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-199" data-mp="lhb4rvs95xh4">
              Nur heute
            </p>
            <p className="mt-3 flex items-center justify-center gap-3" data-id="element-200" data-mp="hi2bes14k1m3">
              <span className="text-4xl leading-none sm:text-5xl" aria-hidden="true" data-id="element-201" data-mp="1wvev8rzmt3hf">
                🏆
              </span>
              <span className="font-display text-7xl font-extrabold leading-none tracking-tight text-brand sm:text-8xl" data-id="element-202" data-mp="1sx7ehx564268">
                17,99&nbsp;€
              </span>
            </p>
            <p className="mt-4 flex items-center justify-center gap-2 text-sm font-medium text-navy/70" data-id="element-203" data-mp="25f1rlzs4x2oh">
              <CreditCardIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-204" data-mp="1qias7qignqyv" />
              Einmalzahlung, lebenslanger Zugriff. Kein Abonnement.
            </p>
          </div>

          <CtaButton className="mt-6 w-full" data-id="element-205" data-mp="2j6gdqfhc9jzr" />

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-semibold text-navy/70" data-id="element-206" data-mp="2o48b3p0r5ybc">
            {offerGuarantees.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-207" data-mp="29d994wufa80q">
                <CheckIcon className="h-3.5 w-3.5 text-leaf" strokeWidth={3} aria-hidden="true" data-id="element-208" data-mp="2ed3ygvyjupjo" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}